import React, { useRef, useEffect } from 'react';
import './Character.css';
import {
  registerCutout,
  unregisterCutout,
  findOpaqueCutout,
  syncCutoutHover
} from '../utils/cutoutHit';

const Character = ({ name, image, position, sns }) => {
  const canvasRef = useRef(null);
  const imgRef = useRef(null);

  useEffect(() => {
    const img = imgRef.current;
    const canvas = canvasRef.current;

    if (!img || !canvas) return;

    const loadImage = () => {
      canvas.width = img.naturalWidth;
      canvas.height = img.naturalHeight;
      const ctx = canvas.getContext('2d', { willReadFrequently: true });
      ctx.clearRect(0, 0, canvas.width, canvas.height);
      ctx.drawImage(img, 0, 0);
      registerCutout(img, canvas);
    };

    if (img.complete && img.naturalWidth) {
      loadImage();
    } else {
      img.addEventListener('load', loadImage);
      return () => {
        img.removeEventListener('load', loadImage);
        unregisterCutout(img);
      };
    }

    return () => unregisterCutout(img);
  }, [image]);

  const handleImageClick = (e) => {
    e.preventDefault();
    e.stopPropagation();

    const target = findOpaqueCutout(e.clientX, e.clientY);
    const href = target?.dataset?.href;
    if (href) {
      window.open(href, '_blank');
    }
  };

  const handleImageMouseMove = (e) => {
    syncCutoutHover(e.clientX, e.clientY);
  };

  const handleImageMouseLeave = (e) => {
    syncCutoutHover(e.clientX, e.clientY);
  };

  return (
    <div className={`character character-${position}`}>
      <img
        ref={imgRef}
        src={image}
        alt={name}
        className="character-image"
        data-href={sns}
        crossOrigin="anonymous"
        onClick={handleImageClick}
        onMouseMove={handleImageMouseMove}
        onMouseLeave={handleImageMouseLeave}
      />
      <canvas ref={canvasRef} style={{ display: 'none' }} />
      <div className="character-name">{name}</div>
    </div>
  );
};

export default Character;
